<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="termsAndCondtions"
          ><span class="fs-3">{{
            'communicationModule.termsAndCondtions' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" id="termsAndCondtions" class="card-body">
      <ng-container *ngFor="let title of sectionTitle">
        <fieldset
          *ngFor="let subTitle of subSectionTitle[title].name; let i = index"
          class="mb-4"
        >
          <legend class="form-label" id="{{ subTitle }}-{{ i }}">
            {{ subTitle | translate }}
          </legend>
          <div class="row g-2">
            <ng-container *ngFor="let langCode of availableLanguageCodes">
              <div class="col-lg-6" *ngIf="availableLanguages[langCode]">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-{{ langCode }}"
                      id="lang-{{ subTitle }}-{{ i }}"
                      role="img"
                      attr.aria-label="{{ 'wcag.' + langCode | translate }}"
                    >
                    </span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    rows="8"
                    attr.aria-labelledby="{{ subTitle }}-{{ i }} lang-{{
                      subTitle
                    }}-{{ i }}"
                    formControlName="{{ langCode }}{{
                      subSectionTitle[title].formControlName[i]
                    }}"
                  />
                </div>
              </div>
            </ng-container>
          </div>
        </fieldset>
      </ng-container>

      <div class="mb-4">
        <label class="form-label">{{
          'communicationModule.termsFooterHTML' | translate
        }}</label>
        <summernote-languages
          [formData]="form"
          [summerNoteFieldEn]="'en_terms_conditions_footer'"
          [summerNoteFieldNl]="'nl_terms_conditions_footer'"
          [summerNoteFieldDe]="'de_terms_conditions_footer'"
          [summerNoteFieldFr]="'fr_terms_conditions_footer'"
        ></summernote-languages>
      </div>

      <div class="d-flex justify-content-end pt-3">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
  <!-- End Card -->
</form>
